<template>
  <div :class="[getSelectedDEV && 'dev-selected-component']" @contextmenu="selectComponentDEV($event, schema.model)">
    <v-card class="card-icon" :href="computedValue" v-bind="schema.attributesCard" @click="checkIsFileDownload()" :disabled="schema.readonly">
      <v-icon v-text="schema.attributesIcon.icon" v-bind="schema.attributesIcon"></v-icon>
      <h3 v-text="schema.attributesTitle.title" v-bind="schema.attributesTitle"></h3>

      <p class="mb-0" v-if="schema.attributesSubtitle" v-text="schema.attributesSubtitle.title" v-bind="schema.attributesSubtitle" />

      <span v-if="isString && !componentIsDownload" v-text="value" v-bind="schema.attributesDescription"></span>

      <number
        v-else-if="!isString && !componentIsDownload"
        v-bind="schema.attributesDescription"
        ref="number"
        :from="0"
        :format="theFormat"
        :to="value"
        :duration="3"
        easing="Power4.easeOut"
      />
    </v-card>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import componentsLinkMixins from '@/mixins/components-link-mixins';
import pageServices from '@/services/page';

export default {
  mixins: [abstractField, devComponentMixin, componentsLinkMixins],

  data() {
    return {
      isString: true
    };
  },

  async mounted() {
    this.schema = await this.setup(this.schema);
    this.checkType();
    this.attributesSchemaComponent();
  },

  methods: {

    async setup(schema){
      return await this.getModel(schema);
    },

    async getModel(schema) {
      if (schema.procedure) {
        let procedure = {
          name: schema.procedure,
          page: this.model.Page
        };
        const { data } = await pageServices.executeProcedureAction(procedure);

        if (data.values.length) {
          const { ds_title, ds_subtitle } = data.values[0];

          schema.attributesTitle.title = ds_title;
          schema.attributesSubtitle.title = ds_subtitle;
        }
      }
      return schema;
    },
    theFormat(number) {
      return number.toFixed(0);
    },

    checkType() {
      if (/^[1-9]\d*(\.\d+)?$/.test(this.value)) {
        this.isString = false;
        this.$refs.number && this.$refs.number.play();
      } else {
        this.isString = true;
      }
    }
  },

  watch: {
    value(newValue, oldValue) {
      this.checkType();
    }
  }
};
</script>

<style lang="scss" scoped>
.card-icon {
  padding: 10px;
  text-align: center;
}
</style>
